import Text from 'components/v4/Text';
import { MdFileCopy } from 'react-icons/md';
import { HStack, IconButton, Tooltip } from '@chakra-ui/react';
import { iconStyling } from '../agGridStyles';
import { useDateFormatter } from '../../../../hooks/useDateFormatter';
import useCellHover from '../hooks/useCellHover';

const UTCTimeCellRenderer = ({ value, valueFormatted }) => {
    const { isHovered, containerRef } = useCellHover();
    // Use user's format preferences and convert the UTC API value to the user's timezone
    // Always use raw API value, ignore valueFormatted to ensure consistent timezone handling
    const formatDate = useDateFormatter();
    const formattedValue = formatDate(value);
    return (
        <HStack ref={containerRef} justifyContent="space-between">
            <Text isTruncated>{formattedValue}</Text>
            {isHovered && (
                <Tooltip label="Copy to clipboard">
                    <IconButton
                        sx={iconStyling}
                        size="sm"
                        variant="ghost"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(formattedValue);
                        }}>
                        <MdFileCopy />
                    </IconButton>
                </Tooltip>
            )}
        </HStack>
    );
};

export default UTCTimeCellRenderer;
